import { Header } from "antd/lib/layout/layout";
import styled from "styled-components";

const NavbarStyles = styled(Header)`
  background-color: white;
  display: flex;
  justify-content: center;
  column-gap: 24px;
`;

export default NavbarStyles;
